class ImageError4i {
    constructor() {
        this.webpSupported = true;
        this.images = document.querySelectorAll("img");
        this.preloadMap = new WeakMap(); // safer than setting custom props on DOM
        this.observer = new IntersectionObserver(this.handleIntersections, { rootMargin: "0px" });
        this.imageSwapPromise = null;

        this.onPreloadSuccess = this.onPreloadSuccess.bind(this);
        this.onPreloadError = this.onPreloadError.bind(this);
        //this.setupPreload = this.setupPreload.bind(this);
    }

    async init() {
        this.webpSupported = await this.supportsWebP();

        if (!this.webpSupported) {
            const swapImage = await this.loadSwapImage();
            for (const image of this.images) {
                await swapImage.switchWebpImage(image);
            }
        }

        for (const image of this.images) {
            this.observer.observe(image);
        }
    }

    async supportsWebP() {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => resolve(img.width > 0 && img.height > 0);
            img.onerror = () => resolve(false);
            img.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
        });
    }

    handleIntersections = (entries) =>{
        for (const entry of entries) {
            const image = entry.target;
            if (entry.isIntersecting && !image.dataset.hasPreloader) {
                this.setupPreload(image);
                this.observer.unobserve(image);
            }
        }
    };

    setupPreload(image) {
        const preload = new Image();
        this.preloadMap.set(preload, image);

        preload.addEventListener("load", this.onPreloadSuccess);
        preload.addEventListener("error", this.onPreloadError);

        image.dataset.hasPreloader = "true";
        preload.src = image.getAttribute("src");
    }

    onPreloadSuccess(e){
        const preload = e.target;
        const image = this.preloadMap.get(preload);
        if (image) image.src = preload.src;
    }

    onPreloadError(e){
        const preload = e.target;
        const image = this.preloadMap.get(preload);
        if (image) this.showFallbackIcon(image);
    }

    showFallbackIcon(image) {
        const styles = window.getComputedStyle(image);
        const fallback = document.createElement("div");
        fallback.classList.add("missingImgSVG", "inlineBlock", "bkgdLtGray", "roundCorners3", "textCenter");

        fallback.innerHTML = `
            <svg class="textDarkestGray margin20" role="img" focusable="false" height="32px" width="32px" aria-label="New image coming soon">
                <use xlink:href="#svgIcon-artwork"></use>
            </svg>
        `;

        const cloneStyles = [
            "position", "bottom", "left", "top", "right", "vertical-align",
            "margin-bottom", "margin-left", "margin-right", "margin-top"
        ];

        cloneStyles.forEach((prop) => {
            const val = styles.getPropertyValue(prop);
            if (val && val !== "static") fallback.style[prop] = val;
        });

        image.style.display = "none";
        image.after(fallback);
    }

    async loadSwapImage() {
        if (!this.imageSwapPromise) {
            this.imageSwapPromise = import('./webpsupport.js') 
                .then(({ default: WebpImageSwap }) => WebpImageSwap) 
                .catch((error) => {
                    console.error("Error in loadSwapImage: Failed to load swap image module:", error);
                    this.imageSwapPromise = null; // Reset to allow retry
                    return null;
                });
        }
        return this.imageSwapPromise;
    }
}

export default new ImageError4i();